// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"8b9150b1","141":"666dc4ee","205":"7dd814de","207":"33170d17","220":"b53c45b5","224":"cdfbb393","255":"24cef632","279":"d8bc6adc","395":"c85a5ef0","859":"af6e9c28","890":"8d64a930","935":"4f8beecd","983":"9d2055ed"}[chunkId] + ".chunk.js";
};